import React from 'react';
import { Type, MessageSquare } from 'lucide-react';

const TextInputBox = ({ value, onChange }) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length <= 80) {
      onChange(newValue);
    }
  };

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return React.createElement('div', { className: 'card animate-slide-up' },
    React.createElement('div', {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '16px'
      }
    },
      React.createElement(Type, { size: 24, color: 'var(--secondary)' }),
      React.createElement('h3', { className: 'subtitle' }, 'Custom Text')
    ),
    React.createElement('p', null, 'Add text to be printed on your t-shirt:'),
    React.createElement('div', {
      style: {
        position: 'relative',
        marginTop: '16px',
        transition: 'all var(--transition-speed) ease'
      }
    },
      React.createElement('textarea', {
        value,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        maxLength: 80,
        className: 'input',
        placeholder: 'Enter your t-shirt text here...',
        style: {
          minHeight: '120px',
          resize: 'vertical',
          transition: 'all var(--transition-speed) ease',
          transform: isFocused ? 'scale(1.01)' : 'scale(1)'
        }
      }),
      value.length === 0 && !isFocused && React.createElement('div', {
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          animation: 'pulse 3s infinite'
        }
      },
        React.createElement(MessageSquare, { size: 20 }),
        React.createElement('span', null, 'Express yourself!')
      )
    ),
    React.createElement('div', {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '8px'
      }
    },
      React.createElement('span', {
        style: {
          fontSize: '0.8rem',
          opacity: 0.7,
          color: value.length === 80 ? 'red' : 'inherit'
        }
      }, `${value.length}/80 characters`),
      React.createElement('span', {
        style: {
          fontSize: '0.8rem',
          opacity: 0.7
        }
      }, 'Max: 80 characters')
    )
  );
};

export default TextInputBox;
